import Button from '@sendsprint/ui-react/dist/components/Button';
import Icon from '@sendsprint/ui-react/dist/components/Icon';
import CloseOutline from '@sendsprint/ui-react/dist/icons/CloseOutline';
import React from 'react';

interface Props {
  onClick?: () => void;
}

const CloseBtn = ({ onClick }: Props) => {
  return (
    <Button
      onClick={onClick}
      label={<Icon svg={CloseOutline} size={24} />}
      variant="tertiary"
      className="ss-p-0"
    />
  );
};

export default CloseBtn;
